import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";
import { reducerPaths } from "../../app/reducerPaths";

export const carDetailsApi = createApi({
  reducerPath: reducerPaths.carDetailsApi,
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    vehicleOfferPrice: builder.query({
      query: ({ storedVehicleId, vin, mileage, trim, year, make, model }) =>
        `/seller/vehicleofferprice/${storedVehicleId}/${vin}/${mileage}/${trim}/${year}/${make}/${model}`,
    }),
    getLiveAuctionTimer: builder.query({
      query: ({ vehicleId }) => {
        return {
          url: `/timeoutdetails/${vehicleId}`,
        };
      },
    }),
    getAgentDetails: builder.query({
      query: ({ vehicleId }) => {
        return `agent/agentdetails/${vehicleId}`;
      },
    }),
    getVehicleDetails: builder.query({
      query: ({ vehicleId }) => `/seller/vehicle/${vehicleId}`,
    }),
  }),
});

export const {
  useVehicleOfferPriceQuery,
  useGetLiveAuctionTimerQuery,
  useGetAgentDetailsQuery,
  useGetVehicleDetailsQuery,
  useLazyGetVehicleDetailsQuery,
  useLazyVehicleOfferPriceQuery,
  useLazyGetLiveAuctionTimerQuery,
  useLazyGetAgentDetailsQuery
} = carDetailsApi;
